// Utilidades pequeñas compartidas.

/** Alfabeto de códigos de seguridad de check-in: sin caracteres ambiguos (0/O, 1/I, 2/Z, 5/S, 8/B). */
export const SECURITY_CODE_ALPHABET = 'ACDEFGHJKLMNPQRTUVWXY34679';
export const SECURITY_CODE_LENGTH = 4;

export function isValidSecurityCode(code: string): boolean {
  if (typeof code !== 'string' || code.length !== SECURITY_CODE_LENGTH) return false;
  return [...code].every((c) => SECURITY_CODE_ALPHABET.includes(c));
}

/**
 * Código del registro previo desde el teléfono: «PC-» y 6 caracteres del mismo alfabeto (lo que
 * contiene el QR). Acepta minúsculas, sin guion o con espacios, como lo escriba una persona o un escáner.
 */
export function normalizePrecheckCode(raw: string): string | null {
  const m = /^\s*PC-?\s*([A-Z0-9]{6})\s*$/i.exec(raw);
  return m ? `PC-${m[1]!.toUpperCase()}` : null;
}

/** Nombre para mostrar: apodo si existe, si no el nombre de pila. */
export function displayName(p: { firstName: string; lastName: string; nickname?: string | null }): string {
  const first = p.nickname?.trim() || p.firstName.trim();
  return `${first} ${p.lastName.trim()}`.trim();
}

/** Texto sin acentos y en minúsculas, para comparar búsquedas. */
export function foldText(s: string): string {
  return (s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
}

export function slugify(s: string): string {
  return foldText(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
}

export function initials(first: string, last: string): string {
  return `${(first || '?')[0] ?? ''}${(last || '')[0] ?? ''}`.toUpperCase();
}

/** Ruta interna a la que se puede volver tras iniciar sesión. Los navegadores tratan `/\sitio` y `//sitio` como otro sitio e ignoran tabuladores y saltos de línea. */
export function safeNextPath(next: string | null | undefined): string | null {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return null;
  return /[\\\u0000-\u001f]/.test(next) ? null : next;
}
